import * as React from 'react';
import { Tracker } from './tracker';

const tracker = Tracker.getInstance();

const context = React.createContext<Tracker>(tracker);

export const TrackingConsumer = context.Consumer;
